import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Student } from 'src/app/interfaces/student';
import { ErrorService } from 'src/app/services/error.service';
import { StudentService } from 'src/app/services/student.service';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.css']
})
export class StudentComponent implements OnInit {
  listStudents: Student[] = [];
  filteredStudents: Student[] = [];
  loading = false;
  passwordVisible: boolean[] = [];

  constructor(
    private _studentService: StudentService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListStudents();
  }

  togglePasswordVisibility(index: number): void {
    this.passwordVisible[index] = !this.passwordVisible[index];
  }

  getListStudents() {
    this.loading = true;
    this._studentService.getListStudents().subscribe({
      next: (data: Student[]) => {
        this.listStudents = data;
        this.filteredStudents = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de estudiantes:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  onSearch(event: Event) {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredStudents = this.listStudents.filter(
      (student) =>
        student.name.toLowerCase().includes(searchTerm) ||
        student.lastname.toLowerCase().includes(searchTerm) ||
        student.ci.toLowerCase().includes(searchTerm)
    );
  }

  deleteStudent(id: number) {
    this.loading = true;
    this._studentService.deleteStudentRegistration(id).subscribe({
      next: () => {
        this.toastr.warning(
          'El estudiante, su usuario y sus relaciones dependientes fueron eliminados con exito',
          'Estudiante eliminado'
        );
        this.getListStudents();
      },
      error: (error) => {
        console.error('Error al eliminar el estudiante:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  updateStudentStatus(id: number, status: number) {
    const newStatus = status === 0 ? 1 : 0;
    this.loading = true;

    this._studentService.updateStudentStatus(id, newStatus).subscribe({
      next: () => {
        this.getListStudents();
        const message = newStatus === 0 ? 'deshabilitado' : 'habilitado';
        this.toastr.warning(
          `El estudiante y su usuario fueron ${message}s con exito`,
          `Estudiante ${message}`
        );
      },
      error: (error) => {
        console.error('Error al actualizar el estado del estudiante:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  disableAllStudents() {
    if (confirm('Esta seguro de deshabilitar TODOS los estudiantes?')) {
      this.loading = true;
      this._studentService.disableAllStudents().subscribe({
        next: (res: any) => {
          this.toastr.success(
            `Deshabilitados: ${res.affected.students} estudiantes y ${res.affected.users} usuarios`,
            'Exito'
          );
          this.getListStudents();
        },
        error: (error) => {
          this._errorService.msjError(error);
          this.loading = false;
        }
      });
    }
  }
}
